// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardCardSkeleton {
  width: 100%;
  height: 297px;
  border-radius: 12px;
  background-color: var(--color_neutral_200);
  overflow: hidden;
}
.DashboardCardSkeleton-thumbnail {
  background-color: var(--color_neutral_400);
  height: 138px;
}
.DashboardCardSkeleton-content {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px 32px;
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardCard/components/DashboardCardSkeleton/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AACF;AACE;EACE,0CAAA;EACA,aAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AAAJ","sourcesContent":[".DashboardCardSkeleton {\n  width: 100%;\n  height: 297px;\n  border-radius: 12px;\n  background-color: var(--color_neutral_200);\n  overflow: hidden;\n\n  &-thumbnail {\n    background-color: var(--color_neutral_400);\n    height: 138px;\n  }\n\n  &-content {\n    display: flex;\n    flex-direction: column;\n    row-gap: 16px;\n    padding: 16px 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
